package dev.mobilearchitecture.web

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.color

/**
 * @property nearBackground A useful color to apply to a container that should differentiate itself from the background
 *   but just a little.
 */
class SitePalette(
    val nearBackground: Color,
    val cobweb: Color,
    val brand: Brand,
) {
    class Brand(
        val primary: Color = Color.rgb(0x3C83EF),
        val accent: Color = Color.rgb(0xF3DB5B),
    )
}

object SitePalettes {
    val light = SitePalette(
        nearBackground = Color.rgba(255, 255, 255, 0.05f), // Translucent off-white
        cobweb = Colors.LightGray,
        brand = SitePalette.Brand(
            primary = Color.rgb(0x4F46E5), // Indigo 600
            accent = Color.rgb(0x10B981), // Emerald 500
        )
    )
    val dark = SitePalette(
        nearBackground = Color.rgba(255, 255, 255, 0.05f), // Translucent off-white
        cobweb = Colors.LightGray.inverted(),
        brand = SitePalette.Brand(
            primary = Color.rgb(0x6366F1), // Indigo 500
            accent = Color.rgb(0x34D399), // Emerald 400
        )
    )
}

fun ColorMode.toSitePalette(): SitePalette {
    return when (this) {
        ColorMode.LIGHT -> SitePalettes.light
        ColorMode.DARK -> SitePalettes.dark
    }
}

@InitSilk
fun initTheme(ctx: InitSilkContext) {
    ctx.config.initialColorMode = ColorMode.LIGHT
    ctx.theme.palettes.light.background = Colors.Transparent // Hero section background transparency
    ctx.theme.palettes.light.color = Color.rgb(0x1E293B) // Dark text for general light sections

    ctx.theme.palettes.dark.background = Colors.Transparent
    ctx.theme.palettes.dark.color = Color.rgb(0xF8FAFC) // Slate 50
}
